var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-time-entries"},[(!_vm.$can('visit', 'TimeEntries'))?_c('NotLoggedPanel',{attrs:{"user":_vm.user}}):_vm._e(),(_vm.$can('visit', 'TimeEntries'))?_c('UserTimeEntriesList'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }